module.exports = __webpack_public_path__ + "static/far-cry_prize-b3eafee81eee2efdb1672a2c7769d387.jpg";